/*
  Raeumt die Filter-Anzeige auf Kollektions- und Suchseiten auf.

  A) Groessen-Beschriftung: "EU 42,5 UK 8" und "EU 42.5 UK 8" werden "EU 42.5".
  B) Groessen-Dubletten: filtert ein Chip mehrere Rohschreibweisen derselben
     Groesse, erzeugt Shopify mehrere gleich beschriftete Pills. Es bleibt eine.
  C) Zustand: der Metafeldwert ist bewusst englisch ("New"/"Used"), weil
     Metafeldwerte nicht uebersetzbar sind. Auf der deutschen Seite wird das
     Label in der Filterliste zu "Neu"/"Gebraucht".

  Sicherheitsregel fuer B: eine Pill wird NUR angefasst, wenn sich ihr Link
  von der aktuellen Adresse in genau einem Groessen-Wert unterscheidet.
  Damit ist sie nachweislich eine Groessen-Pill. Pills fuer Marke, Sohle,
  Zustand, Preis oder Verfuegbarkeit erfuellen das nie und bleiben unberuehrt.

  Hinweis: alle Muster ueber new RegExp bauen, keine Regex-Literale mit
  Backslash-Klassen. Die Datei wird ueber die Admin-API geschrieben, dabei
  sind Backslashes in Literalen schon zweimal falsch angekommen.
*/
(function () {
  var SIZE = 'filter.v.option.size';
  var COND = 'filter.p.m.custom.condition';
  var Z = '[ \\u00a0\\t]';
  var D = '[0-9]';
  var WS = new RegExp(Z + '+', 'g');
  var RE = new RegExp(
    'EU' + Z + '*(' + D + '{2}(?:[.,]' + D + '+|' + Z + '+' + D + '/' + D + ')?)' +
      '(?:' + Z + '*UK' + Z + '*' + D + '+(?:[.,]' + D + '+)?)?',
    'g'
  );
  var SEL = '.active-facets, facet-filters-form, .mobile-facets, .facets';

  function istDeutsch() {
    var l = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    return l.indexOf('de') === 0;
  }

  /* ---------- A: Groessen-Beschriftung ---------- */

  function sauber(text) {
    return text.replace(RE, function (treffer, eu) {
      return 'EU ' + eu.replace(',', '.');
    });
  }

  function walk(root) {
    if (!root) return;
    var tw = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    var n;
    while ((n = tw.nextNode())) {
      if (n.nodeValue && n.nodeValue.indexOf('UK') !== -1) nodes.push(n);
    }
    for (var i = 0; i < nodes.length; i++) {
      var next = sauber(nodes[i].nodeValue);
      if (next !== nodes[i].nodeValue) nodes[i].nodeValue = next;
    }
  }

  /* ---------- C: Zustand eindeutschen ---------- */

  var ZUSTAND = { New: 'Neu', Used: 'Gebraucht' };

  function zustand(root) {
    if (!istDeutsch()) return;
    var inputs = root.querySelectorAll('input[name="' + COND + '"]');
    for (var i = 0; i < inputs.length; i++) {
      var wert = inputs[i].value;
      var ziel = ZUSTAND[wert];
      if (!ziel) continue;
      var label = inputs[i].closest('label');
      if (!label) continue;
      var tw = document.createTreeWalker(label, NodeFilter.SHOW_TEXT, null);
      var n;
      while ((n = tw.nextNode())) {
        if (n.nodeValue && n.nodeValue.indexOf(wert) !== -1) {
          n.nodeValue = n.nodeValue.split(wert).join(ziel);
        }
      }
    }
  }

  /* ---------- B: Groessen-Dubletten ---------- */

  function kanon(wert) {
    var s = String(wert).replace(WS, ' ').replace(/,/g, '.').split('UK')[0].replace(/EU/g, '').trim();
    var flach = s.replace(' 1/3', '.33').replace(' 2/3', '.67').replace(' 1/2', '.5').replace(WS, '');
    var zahl = parseFloat(flach);
    if (!isFinite(zahl)) return null;
    return zahl.toFixed(2);
  }

  function aktuelleGroessen() {
    try {
      return new URLSearchParams(window.location.search).getAll(SIZE);
    } catch (e) {
      return [];
    }
  }

  function weggelassen(href, aktuell) {
    var u;
    try {
      u = new URL(href, window.location.origin);
    } catch (e) {
      return [];
    }
    var drin = u.searchParams.getAll(SIZE);
    var rest = aktuell.slice();
    for (var i = 0; i < drin.length; i++) {
      var pos = rest.indexOf(drin[i]);
      if (pos > -1) rest.splice(pos, 1);
    }
    return rest;
  }

  function ohneWerte(href, werte) {
    var u = new URL(href, window.location.origin);
    var behalten = u.searchParams.getAll(SIZE).filter(function (v) {
      return werte.indexOf(v) === -1;
    });
    u.searchParams.delete(SIZE);
    for (var i = 0; i < behalten.length; i++) u.searchParams.append(SIZE, behalten[i]);
    return u.pathname + (u.search || '');
  }

  function huelle(el, container) {
    var k = el;
    while (k.parentElement && k.parentElement !== container) k = k.parentElement;
    return k.parentElement === container ? k : el;
  }

  function dubletten(container) {
    var aktuell = aktuelleGroessen();
    if (aktuell.length < 2) return;

    var links = container.querySelectorAll('a[href]');
    var gruppen = {};

    for (var i = 0; i < links.length; i++) {
      var fehlt = weggelassen(links[i].getAttribute('href'), aktuell);
      if (fehlt.length !== 1) continue;
      var schluessel = kanon(fehlt[0]);
      if (!schluessel) continue;
      if (!gruppen[schluessel]) gruppen[schluessel] = { pills: [], werte: [] };
      gruppen[schluessel].pills.push(links[i]);
      if (gruppen[schluessel].werte.indexOf(fehlt[0]) === -1) gruppen[schluessel].werte.push(fehlt[0]);
    }

    Object.keys(gruppen).forEach(function (k) {
      var g = gruppen[k];
      if (g.pills.length < 2) return;
      g.pills[0].setAttribute('href', ohneWerte(g.pills[0].getAttribute('href'), g.werte));
      for (var i = 1; i < g.pills.length; i++) {
        var el = huelle(g.pills[i], container);
        if (el.parentNode) el.parentNode.removeChild(el);
      }
    });
  }

  /* ---------- Steuerung ---------- */

  var timer = null;

  function run() {
    var roots = document.querySelectorAll(SEL);
    for (var i = 0; i < roots.length; i++) {
      walk(roots[i]);
      zustand(roots[i]);
    }
    var boxen = document.querySelectorAll('.active-facets');
    for (var j = 0; j < boxen.length; j++) dubletten(boxen[j]);
  }

  function schedule() {
    window.clearTimeout(timer);
    timer = window.setTimeout(run, 80);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', schedule);

  if (window.MutationObserver && document.body) {
    var beobachten = function (records) {
      for (var i = 0; i < records.length; i++) {
        var t = records[i].target;
        if (t && t.closest && t.closest(SEL)) {
          schedule();
          return;
        }
      }
    };
    new MutationObserver(beobachten).observe(document.body, { childList: true, subtree: true });
  }
})();